import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { Mutations } from '@shared/api';
import { notNil } from '@shared/util/notNil';

type CreateEntitiesFunction = (
  entities: MBAPI.CreateWorkflowEntity[],
) => Promise<MBAPI.CreateWorkflowEntitiesMutation_createWorkflowEntities_entities[]>;

export function useCreateEntitiesMutation(workflowTemplateId: string): CreateEntitiesFunction {
  const [createEntities] = useMutation<
    MBAPI.CreateWorkflowEntitiesMutation,
    MBAPI.CreateWorkflowEntitiesMutationVariables
  >(Mutations.entity.createWorkflowEntities);

  return useCallback(
    async (entities: MBAPI.CreateWorkflowEntity[]) => {
      const input = {
        workflowTemplateId,
        entities,
      };
      const { data } = await createEntities({
        variables: { input },
      });

      const createdEntities = data?.createWorkflowEntities?.entities?.filter(notNil);

      if (createdEntities?.length === entities.length) {
        return createdEntities;
      } else {
        throw new Error('Failed to create entities');
      }
    },
    [workflowTemplateId, createEntities],
  );
}
